import { render, staticRenderFns } from "./MiniViewer.vue?vue&type=template&id=81817a30&"
import script from "./MiniViewer.vue?vue&type=script&lang=js&"
export * from "./MiniViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports